<template>
    <div class="container">
        <div class="rating q-mb-md row items-center" :class="{'justify-center': !$breakpoints.isGreaterThan('xs')}">
            <h5 class="q-ma-none">{{ $T('rate this') }} {{ label }}</h5>
            <q-rating :disable="!user"
                    class="yellow"
                    v-model="inputValue"
                    @input="onInput"
                    icon="fa fa-star"
                    :max="5"
            />
        </div>
    </div>
</template>

<script>
    import {
        QRating,
        Cookies
    } from 'quasar-framework'
    import axios from 'axios';
    import {mapGetters} from 'vuex'

    export default {
        name: 'VRating',

        components: {
            QRating
        },

        props: {
            contentType: {
                type: String,
                requered: true
            },
            contentId: {
                type: Number,
                requered: true
            },
            value: {
                type: Number,
                required: true
            },
            label: {
                type: String,
                default() {
                    return this.$T('item')
                }
            }
        },

        data() {
            return {
                inputValue: this.value
            }
        },
        computed: {
            ...mapGetters({
                user: 'auth/user',
            }),

        },
        methods: {
            onInput() {
                axios.post(`${config.appUrl}/${this.portal_base}/${this.user.id}/rate/${this.contentType}/${this.contentId}/save`, {value: this.inputValue, user: this.user})
                    .then(({data}) => {

                    })
                    .catch(error => {

                    })
            },
            average() {
                axios.get(`${config.appUrl}/${this.portal_base}/${this.user.id}/rate/${this.contentType}/${this.contentId}/`)
                    .then(({data}) => {
                        this.inputValue = data;
                    })
                    .catch(error => {

                    })
            }

        },
        mounted() {
            this.portal_base = Cookies.get('portal')
            this.average();
        }
    }
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/front/Rating.vue